// removed by extract-text-webpack-plugin
module.exports = {"wireframesImage":"_2Tnq","fontContainer":"_3VD-","text":"DA3m","imageContainer":"_15Wt","fontImage":"_2JLW","colorsImage":"_3CFY"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/CaseStudies/ESENCaseStudy/styles.scss
// module id = 522
// module chunks = 0